import {
    getBikeBodyTypeRequest,
    getBikeCharacteristicRequest,
    getBikeMarkRequest,
    getBikeModelRequest,
    getBikeModificationRequest,
    getBikeTechDataRequest,
    getBikeTypeRequest,
} from '../../../services/network/fields/bike';

class BikeDataFieldsService {
    async getBikeType() {
        return await getBikeTypeRequest();
    }

    async getBikeMark(type) {
        return await getBikeMarkRequest(type);
    }

    async getBikeModel(params) {
        return await getBikeModelRequest(params);
    }

    async getBikeBodyType(params) {
        return await getBikeBodyTypeRequest(params);
    }

    async getBikeModification(params) {
        return await getBikeModificationRequest(params);
    }

    async getBikeCharacteristic(params) {
        return await getBikeCharacteristicRequest(params);
    }

    async getBikeTechData(params) {
        return await getBikeTechDataRequest(params);
    }
}

export const BikeDataLadderSearchService = new BikeDataFieldsService();
